import { TechSupportContactUs } from "../../../../src/components/tech-supportContactUs";
import * as React from 'react';
export default {
  TechSupportContactUs,
  React
};